module.exports = __webpack_public_path__ + "static/list-title-bg6@2x-719135645bf3fbe6f31d5d088ee18eae.png";